import { render } from "./ClearanceCertificatePrint.vue?vue&type=template&id=21ad4e6f&scoped=true"
import script from "./ClearanceCertificatePrint.vue?vue&type=script&lang=js"
export * from "./ClearanceCertificatePrint.vue?vue&type=script&lang=js"

import "./ClearanceCertificatePrint.vue?vue&type=style&index=0&id=21ad4e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ad4e6f"]])

export default __exports__